<template>
  <div>
    <b-row>
      <b-col sm="6">
        <form>
          <b-form-group label="Tipo de transporte:">

            <el-select v-model="selectedTransporte.tipo_transporte" size="small" >
              <el-option v-for="item in tipos_transporte_list"
                         :key="item.id"
                         :label="item.lista"
                         :value="item.id"
              />

            </el-select>
          </b-form-group>
          <b-form-group label="No UN:">

            <el-select v-model="selectedTransporte.noun"
                       size="small"
                       filterable
                       clearable
                       remote
                       :remote-method="getGre"
            >
              <el-option v-for="(item, indice) in guiaRespuestaEmergencia"
                         :key="item.codigo_un + indice"
                         :label="item.codigo_un === 'NO REGULADO' ? item.codigo_un : (item.codigo_un + ' - ' + item.gre + ' | ' + item.peligro_un)"
                         :value="item.codigo_un"
              >
                <span v-if="item.codigo_un === 'NO REGULADO'">{{ item.codigo_un }}</span>
                <span v-else>{{ item.codigo_un }} - {{ item.gre }} | {{ item.peligro_un }}</span>
              </el-option>

            </el-select>
          </b-form-group>

          <b-form-group label="Peligro Principal:">
            <el-select v-model="selectedTransporte.riesgo_principal"
                       @change="verImagen(selectedTransporte.riesgo_principal != null  ? optprincipal[selectedTransporte.riesgo_principal].imagen : '')"
                       size="small"
                       filterable
                       clearable
            >
              <el-option v-for="item in optprincipal"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value"
              />
            </el-select>
          </b-form-group>

          <b-form-group label="Peligro Secundario:">
            <el-select v-model="selectedTransporte.riesgo_secundario"
                       @change="verImagen1(selectedTransporte.riesgo_secundario != null  ? optsecundario[selectedTransporte.riesgo_secundario].imagen : null)"
                       size="small"
                       filterable
                       clearable
            >
              <el-option v-for="item in optsecundario"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value"
              />
            </el-select>
          </b-form-group>

          <b-form-group label="Peligro Secundario 1:">
            <el-select v-model="selectedTransporte.riesgo_secundario1"
                       @change="verImagen2(selectedTransporte.riesgo_secundario1 != null ? optsecundario1[selectedTransporte.riesgo_secundario1].imagen : null)"
                       size="small"
                       filterable
                       clearable
            >
              <el-option v-for="item in optsecundario1"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value"
              />
            </el-select>
          </b-form-group>

        </form>
      </b-col>
      <b-col sm="6"
             class="mt-4 text-center"
      >
        <b-img fluid
               v-if="selectedTransporte.imagen_principal"
               :src="selectedTransporte.imagen_principal"
               alt="Riesgo Principal"
               class="unPictograma m-2"
               style="max-width: 120px; height:120px;"
        />
        <b-img fluid
               v-if="selectedTransporte.imagen_secundario && selectedTransporte.imagen_secundario !== selectedTransporte.imagen_principal"
               :src="selectedTransporte.imagen_secundario"
               alt="Riesgo Secundario"
               class="unPictograma m-2"
               style="max-width: 120px; height:120px;"
        />
        <b-img fluid
               v-if="selectedTransporte.imagen_secundario1 && selectedTransporte.imagen_secundario1 !== selectedTransporte.imagen_secundario && selectedTransporte.imagen_secundario1 !== selectedTransporte.imagen_principal"
               :src="selectedTransporte.imagen_secundario1"
               alt="Riesgo Secundario1"
               class="unPictograma m-2"
               style="max-width: 120px; height:120px;"
        />
      </b-col>
    </b-row>



    <b-modal hide-footer
             title="Rotulo UN"
             scrollable
             ref="modal_un"
             size="xl"
    >
      <b-embed type="iframe"
               :src="dirRotulo"
               allowfullscreen
      />
    </b-modal>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
// import rotulo from './rotulo.vue';
// import {getAcls} from '../../../plugins/acl';

export default {
  name: 'ModalFormTransportes',
  data() {
    return {
      imagen: null,
      imagen1: null,
      imagen2: null,
      desactivarSelect: false,
      verTabla: false,
      puedeVerRotulo: false,
    };
  },
  async mounted() {
    await this.getRiesgos();
    await this.getTiposTransporte();
    // await this.getUn(this.$route.params.id);

    //Si el primer select (Peligro Principal) es igual a NO APLICA
    //Se desactiva los selects de abajo y se inicializan en NO APLICA
    if (this.selectedTransporte.riesgo_principal === '0') {
      this.desactivarSelect = true;
      this.selectedTransporte.riesgo_secundario = '0';
      this.selectedTransporte.imagen_secundario = null;
      this.selectedTransporte.riesgo_secundario1 = '0';
      this.selectedTransporte.imagen_secundario1 = null;
    }
  },
  components: {
    //rotulo
  },
  computed: {
    ...mapState('nacionesunidas', [
      'optprincipal',
      'optsecundario',
      'optsecundario1',
      'txtprincipal',
      'txtsecundario',
      'txtsecundario1',
      'guiaRespuestaEmergencia',
      'dirRotulo',
      'rotul'
    ]),
    ...mapState('fds_productos', [
      'selectedTransporte',
      'tipos_transporte_list'
    ]),
  },
  methods: {
    verImagen(imagen) {
      this.selectedTransporte.imagen_principal = imagen;
      //Si el primer select (Peligro Principal) es igual a NO APLICA
      //Se desactiva los selects de abajo y se inicializan en NO APLICA
      if (this.selectedTransporte.riesgo_principal === '0') {
        this.desactivarSelect = true;
        this.selectedTransporte.riesgo_secundario = '0';
        this.selectedTransporte.imagen_secundario = null;
        this.selectedTransporte.riesgo_secundario1 = '0';
        this.selectedTransporte.imagen_secundario1 = null;
      } else {
        this.desactivarSelect = false;
      }

    },
    verImagen1(imagen) {
      if (this.selectedTransporte.riesgo_secundario === '0') {
        this.selectedTransporte.imagen_secundario = null;
      } else {
        this.selectedTransporte.imagen_secundario = imagen;
      }
    },
    verImagen2(imagen) {
      if (this.selectedTransporte.riesgo_secundario1 === '0') {
        this.selectedTransporte.imagen_secundario1 = null;
      } else {
        this.selectedTransporte.imagen_secundario1 = imagen;
      }
    },
    filtrarUn(query) {
      if (query.length > 2) {
        this.verTabla = true;
        this.listaGre = this.guiaRespuestaEmergencia.filter((item) => {
          return item.codigo_un.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      } else {
        this.verTabla = false;
        this.listaGre = [];
        return this.listaGre;
      }
    },
    async verRotuloUN(tipo) {
      this.rotul.tipoRotulo = tipo;
      await this.generarRotuloUN(this.$route.params.id);
      this.$refs.modal_un.show();
    },
    ...mapActions('nacionesunidas', [
      'getRiesgos',
      'generarRotuloUN',
      'getGre',
    ]),
    ...mapActions('fds_productos', [
      'getTiposTransporte'
    ]),

  }
};
</script>
<style>
.unPictograma {
  width: 100px;
  height: 100px;
}

.etiqueta-un {
  background-color: #e45e1e;
  padding: 1px 10px;
  border-radius: 6px;
  margin-top: 10px;
}
</style>
